export default __webpack_public_path__ + "static/media/deleteicon.96e77837.svg";